import { type Commands } from '../commands';
import { UUID } from '../uuid/entity';
import { AssetTypes } from './repository';
import { AssetType } from './entity';
import { type AssetTypeData } from './dto';

export class AssetTypesCommands
    implements Commands<AssetTypes, AssetType, AssetTypeData>
{
    addAll(repo: AssetTypes, data: AssetTypeData[]): AssetTypes {
        repo.clear();
        data.forEach((assetData) => {
            this.add(repo, assetData);
        });
        return repo;
    }

    add(repo: AssetTypes, data: AssetTypeData): AssetTypes {
        const asset = new AssetType({
            id: data.id,
            name: data.name,
            label: data.label,
            description: data.description,
            srcId: data.srcId,
            isCustom: data.isCustom ?? false,
        });
        repo.add(asset);
        return repo;
    }

    update(repo: AssetTypes, entity: AssetType): AssetType {
        repo.update(entity);
        return entity;
    }

    remove(repo: AssetTypes, id: string): void {
        repo.remove(id);
    }

    create(repo: AssetTypes, data: Omit<AssetTypeData, 'id'>): AssetType {
        const uuid = new UUID();
        const asset = new AssetType({
            id: uuid.toString(),
            name: data.name,
            label: data.label,
            description: data.description,
            srcId: data.srcId,
            isCustom: data.isCustom,
        });
        repo.add(asset);
        return asset;
    }

    fromJSON(
        entity: AssetType[] | undefined,
        changeCallback: () => void,
    ): AssetTypes {
        const newAssetTypes = new AssetTypes(changeCallback);
        (entity ?? []).forEach((asset) => {
            newAssetTypes.add(
                new AssetType({
                    id: asset.id,
                    name: asset.name,
                    label: asset.label,
                    description: asset.description,
                    srcId: asset.srcId,
                    isCustom: asset.isCustom,
                }),
            );
        });
        return newAssetTypes;
    }
}
